import {useSearchParams, useNavigate} from "react-router-dom";
import LessonNavigation from "../components/lessonNavigation/LessonNavigation";
import StudentStats from "../components/studentStats/StudentStats";
import FilterLayer from "../components/filter/FilterLayer";
import LearningResultsTable from "../components/learningResults/LearningResultsTable";
import {useEffect, useState, useRef} from "react";
import {getClassLessonStage, getClassLessonStageHomework} from "../../../network/Endpoint";
import {checkToast, messageToast} from"../../../components/Toast"
import SideMenu from "../../../components/SideMenu";
import {useRecoilState, useSetRecoilState, useRecoilValue} from "recoil";
import {topMenuTypeState} from "../../../recoil/menuState/topMenuState";
import {lessonClassState, lessonLessonInfoState, lessonStageState} from "../../../recoil/lesson/lessonState";
import {mainClassState} from "../../../recoil/classes/classesState";
import NavigationButton from "../components/lessonNavigation/NavigationButton";
import * as React from "react";

const HomeworkStagePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const isInitialMount = useRef(true);
    const [level, setLevel] = useState(null); // Integer
    const [chapterSeq, setChapterSeq] = useState(null); // Integer
    const [lessonTitle, setLessonTitle] = useState(null);
    const [stageName, setStageName] = useState(""); // String
    const [round, setRound] = useState(0); // Integer
    const [maxRound, setMaxRound] = useState(null);
    const [excellentStudentList, setExcellentStudentList] = useState([]); // List<ExcellentStudentDto>
    const [inCompletedStudentList, setInCompletedStudentList] = useState([]); // List<String>
    const [classStageStudentList, setClassStageStudentList] = useState([]); // List<ClassStageStudentDto>
    const [filterInfoList, setFilterInfoList] = useState([]); // List<FilterInfoDto>
    const [activeFilter, setActiveFilter] = useState();
    const [classId, setClassId] = useRecoilState(lessonClassState);
    const [stageId, setStageId] = useRecoilState(lessonStageState);
    const [lessonInfoId, setLessonInfoId] = useRecoilState(lessonLessonInfoState);
    const mainClass = useRecoilValue(mainClassState);
    const setMenuType = useSetRecoilState(topMenuTypeState);
    const [hwStartAt, setHwStartAt] = useState(null);
    const [hwEndAt, setHwEndAt] = useState(null);

    useEffect(() =>  {
        if(setMenuType){
            setMenuType("classLesson");
        }
    },[setMenuType])


    useEffect(() => {
        if(searchParams.size>0){
            let classIdParam;
            if(searchParams.get("classId")!=null){
                classIdParam = searchParams.get("classId");
                setClassId(classIdParam);
            }else{
                classIdParam = classId;
            }
            let stageIdParam;
            if(searchParams.get("stageId")!=null){
                stageIdParam = searchParams.get("stageId");
                setStageId(stageIdParam);
            }else{
                stageIdParam = stageId;
            }
            let lessonInfoIdParam;
            if(searchParams.get("lessonInfoId")!=null){
                lessonInfoIdParam = searchParams.get("lessonInfoId");
                setLessonInfoId(lessonInfoIdParam);
            }else{
                lessonInfoIdParam = lessonInfoId;
            }
            let roundParam;
            if(searchParams.get("round") != null){
                roundParam = searchParams.get("round");
                setRound(roundParam);
            }else{
                roundParam = null;
            }

            fetchClassLessonStage(classIdParam, stageIdParam, lessonInfoIdParam, roundParam, false).then();

            window.history.replaceState(null, "", "/page/classHomeworkStage"); // 주소창에서 경로를 숨김
        }
    }, [searchParams]);


    const incrementRound = () => {
        if(classId && stageId && lessonInfoId){
            const newRound = (round < maxRound)? round + 1: maxRound;

            fetchClassLessonStage(classId, stageId, lessonInfoId, newRound, false);
        }
    };

    const decrementRound = () => {
        if(classId && stageId && lessonInfoId) {
            const newRound = round > 1 ? round - 1 : 1;

            fetchClassLessonStage(classId, stageId, lessonInfoId,newRound, false);
        }
    };

    const reloadPage = () =>{
        if(classId && stageId && lessonInfoId) {
            fetchClassLessonStage(classId, stageId, lessonInfoId, round, true);
        }
    };

    useEffect(() => {
        if(searchParams.size===0){
            fetchClassLessonStage(classId, stageId, lessonInfoId, round, false).then();
        }
    }, []);

    useEffect(() => {
        // 첫 번째 마운트가 아닌 경우에만 페이지 이동
        if (!isInitialMount.current) {
            navigate("/page/classHomework");
        } else {
            // 첫 번째 마운트 이후 플래그 변경
            isInitialMount.current = false;
        }
    }, [mainClass, navigate]);

    const fetchClassLessonStage = async (classIdParam, stageIdParam,lessonInfoIdParam, round, reloadCheck) => {
        try {
            const body = {
                classId: classIdParam,
                stageId: stageIdParam,
                lessonInfoId: lessonInfoIdParam,
                round: round,
            };
            const res = await getClassLessonStageHomework(body);
            const statusCode = res.data.status.code;
            console.log(res);
            if (statusCode === 'Success') {
                setLevel(res.data.data.level);
                setChapterSeq(res.data.data.chapterSeq);
                setStageName(res.data.data.stageName);
                setLessonTitle(res.data.data.lessonTitle);
                if(res.data.data.maxRound===0){
                    setRound(1);
                }else{
                    setRound(res.data.data.round);
                }
                setMaxRound(res.data.data.maxRound);
                setExcellentStudentList(res.data.data.excellentStudentList);
                setInCompletedStudentList(res.data.data.inCompletedStudentList);
                if(reloadCheck){
                    if(JSON.stringify(classStageStudentList)===JSON.stringify(res.data.data.classStageStudentList)){
                        checkToast("변경된 데이터가 없습니다.")
                    }else{
                        let description = res.data.data.level+"레벨 "+res.data.data.chapterSeq+"단원 / " + res.data.data.stageName;
                        messageToast({message : "데이터가 갱신되었습니다.", description : description});
                    }
                }
                setClassStageStudentList(res.data.data.classStageStudentList);
                setFilterInfoList(res.data.data.filterInfoList);
                setHwStartAt(res.data.data.startAt);
                setHwEndAt(res.data.data.endAt);
            } else {
                alert(`ERROR: 숙제 결과 로딩 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.\n${res.data.status.message}`);
            }
        } catch (error) {
            alert('숙제 결과 로딩 중 오류가 발생했어요.\n아크수학으로 문의해 주세요.');
        }
    };
    return (
        <div className="flex flex-col items-center w-full max-md:max-w-full bg-[#F8F8F8]">
            <div className="flex gap-2 items-center justify-center self-stretch my-auto mt-[60px]">
                <NavigationButton direction="prev"
                                  disabled={round <= 1} // 1 이하로 감소 방지
                                  onClick={decrementRound}/>
                <div className="self-stretch my-auto text-[20px] text-center font-[700] text-[#50555F] w-[120px] mx-8">
                    {round}번째 학습
                </div>
                <NavigationButton direction="next"
                                  disabled={round >= maxRound}
                                  onClick={incrementRound}/>
            </div>
            {hwStartAt && hwEndAt && (
                <div className="flex items-center justify-center self-stretch my-auto text-[14px] font-[700] text-[#50555F] font-semibold text-center text-zinc-60 mt-1 ">
                   ( {hwStartAt} ~ {hwEndAt} )
                </div>
            )}
            {/* Main content section */}
            <div
                className="flex flex-col justify-center px-6 pt-5 pb-6 mt-8 max-w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] w-[1044px] max-md:px-5 max-md:mt-10">
                {/* Header content */}
                <LessonNavigation
                    round={round}
                    maxRound={maxRound}
                    onIncrement={incrementRound}
                    onDecrement={decrementRound}
                    reload={reloadPage}
                    level={level}
                    chapter={chapterSeq}
                    stageName={stageName}
                    lessonTitle={lessonTitle}
                />
            </div>

            {/* Statistics Grid */}
            <div>
                <StudentStats
                    excellentStudentList={excellentStudentList}
                    inCompletedStudentList={inCompletedStudentList}
                    filterInfoList={filterInfoList}
                    classStageStudentList={classStageStudentList}
                />

            </div>
            {/* Statistics Grid */}
            <div>
                <FilterLayer
                    filterInfoList={filterInfoList}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                />

            </div>
            {/* classResults Result Section */}
            <div>
                <LearningResultsTable
                    classStageStudentList={classStageStudentList}
                    activeFilter={activeFilter}
                />
            </div>

            <SideMenu></SideMenu>
        </div>

    );
}

export default HomeworkStagePage;